import { all } from 'route-data/all';
import { jotterFetcher } from 'redux/fetchers/jotter';
import { clientSideMonetateFetcher } from 'redux/fetchers/client-side-monetate';

export const commonClientFetch = all(
  // Any page with the header searchbar needs this jotter.
  jotterFetcher,
  // This is required for any page that uses Monetate for A/B testing
  clientSideMonetateFetcher,
);
